import { useState, useCallback } from 'react';
import { usePharmacy } from '@/context/PharmacyContext';

export default function MobileStickyCTA() {
  const { settings } = usePharmacy();
  const phone = settings?.phone || '(905) 709-9985';
  const phoneRaw = settings?.phone_raw || '9057099985';
  const fax = settings?.fax || '(905) 709-9986';
  const [showToast, setShowToast] = useState(false);

  const handleCopyFax = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(fax);
      setShowToast(true);
      setTimeout(() => setShowToast(false), 2000);
    } catch {
      // clipboard API not available — still show feedback
      setShowToast(true);
      setTimeout(() => setShowToast(false), 2000);
    }
  }, [fax]);

  return (
    <>
      {/* Spacer to prevent content from being hidden behind sticky bar */}
      <div className="h-16 lg:hidden" aria-hidden="true"></div>

      {/* Sticky bar */}
      <div className="fixed bottom-0 left-0 right-0 z-50 lg:hidden">
        {/* Copy feedback toast */}
        <div
          className={`absolute -top-11 left-1/2 -translate-x-1/2 bg-foreground-900 text-background-50 text-xs font-medium px-4 py-2 rounded-full transition-all duration-300 pointer-events-none whitespace-nowrap ${
            showToast ? 'opacity-100 -translate-y-0' : 'opacity-0 translate-y-2'
          }`}
        >
          <i className="ri-check-line mr-1"></i>
          Fax copied!
        </div>

        <div className="bg-background-50 border-t border-background-200 shadow-[0_-4px_20px_rgba(0,0,0,0.08)]">
          <div className="grid grid-cols-2 divide-x divide-background-200">
            {/* Phone — primary action */}
            <a
              href={`tel:${phoneRaw}`}
              className="flex items-center justify-center gap-2 py-3 px-2 bg-primary-500 hover:bg-primary-600 text-background-50 transition-colors cursor-pointer group"
              aria-label={`Call ${phone}`}
            >
              <div className="w-7 h-7 flex items-center justify-center rounded-full bg-background-50/20 group-hover:bg-background-50/30 transition-colors flex-shrink-0">
                <i className="ri-phone-fill text-sm"></i>
              </div>
              <div className="flex flex-col items-start leading-tight min-w-0">
                <span className="text-[9px] font-medium uppercase tracking-wider text-background-50/70">
                  Call
                </span>
                <span className="text-xs font-bold whitespace-nowrap leading-tight">
                  {phone}
                </span>
              </div>
            </a>

            {/* Fax — tap to copy */}
            <button
              onClick={handleCopyFax}
              className="flex items-center justify-center gap-2 py-3 px-2 bg-background-50 hover:bg-background-100 text-foreground-900 transition-colors cursor-pointer group active:bg-background-200"
              aria-label={`Fax: ${fax} — tap to copy`}
            >
              <div className="w-7 h-7 flex items-center justify-center rounded-full bg-background-200 group-hover:bg-background-300 transition-colors flex-shrink-0">
                <i className="ri-printer-line text-sm text-foreground-600"></i>
              </div>
              <div className="flex flex-col items-start leading-tight min-w-0">
                <span className="text-[9px] font-medium uppercase tracking-wider text-foreground-500">
                  Fax
                </span>
                <span className="text-xs font-bold text-foreground-900 whitespace-nowrap leading-tight">
                  {fax}
                </span>
              </div>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}